<template>
  <!-- Charts And Table Placeholders -->
  <el-tabs v-model="activeName">

    <!-- Timeline -->
    <el-tab-pane
      :label="firstTabTitle"
      name="first"
    >
      <ib-charts-placeholder-type />
    </el-tab-pane>
    <!-- /Timeline -->

    <!-- Breakdown -->
    <el-tab-pane
      :label="secondTabTitle"
      name="second"
    >
      <ib-charts-placeholder-type type="breakdown" />
    </el-tab-pane>
    <!-- /Breakdown -->

    <!-- Table -->
    <el-tab-pane
      :label="thirdTabTitle"
      name="third"
    >
      <ib-charts-placeholder-type type="table" />
    </el-tab-pane>
    <!-- /Table -->
  </el-tabs>
  <!-- /Charts And Table Placeholders -->
</template>

<script>
export default {
  name: 'IbChartsPlaceholder',

  props: {
    firstTabTitle: {
      type: String,
      default: function () {
        return this.$t('timeline')
      }
    },
    secondTabTitle: {
      type: String,
      default: function () {
        return this.$t('breakdown')
      }
    },
    thirdTabTitle: {
      type: String,
      default: function () {
        return this.$t('table')
      }
    }
  },

  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>
